import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "platmap-error" }
const _hoisted_2 = { class: "platmap-error__container" }
const _hoisted_3 = { class: "platmap-error__heading" }
const _hoisted_4 = { class: "platmap-error__subheading" }
const _hoisted_5 = { class: "platmap-error__para" }
const _hoisted_6 = { class: "platmap-error__para" }
const _hoisted_7 = { class: "platmap-error__para last" }
const _hoisted_8 = { class: "platmap-error__regionbtn" }
const _hoisted_9 = { class: "caret-down" }
const _hoisted_10 = ["href"]

import { apiMessages } from '../../api/message-api';
import { Regions } from '../../types/error';
import { apiFetchErrorRegions } from '../../api/regions';
import { onMounted, onUnmounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: '404Page',
  setup(__props) {

let message: any = ref({});
let regionsDropdown = ref([] as Regions);
const show = ref(false);

const regionBlurClick = (e: Event) => {
  const dropDownButton = document.querySelector('.platmap-error__btn');
  const dropDownMenu = document.querySelector('.dropdown-menu');
  if (
    dropDownMenu &&
    !dropDownMenu.contains(e.target as Node) &&
    dropDownButton &&
    !dropDownButton.contains(e.target as Node)
  ) {
    show.value = false;
  }
};

const loadMessages = async () => {
  const { messages } = await apiMessages('404Page');
  message.value = messages;
};

const loadRegions = async () => {
  const { regions } = await apiFetchErrorRegions();
  regionsDropdown.value = regions;
}

const showListHandler = () => {
  show.value = !show.value;
}

onMounted(async () => {
  await loadMessages();
  await loadRegions();
  document.addEventListener('click', regionBlurClick)
});

onUnmounted(() => {
  document.removeEventListener('click', regionBlurClick)
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(message).errorName), 1),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(message).errorMessage), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(message).errorParaOne), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(message).errorParaTwo), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(message).errorParaThree), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "platmap-error__btn btn",
          onClick: showListHandler
        }, [
          _createTextVNode(_toDisplayString(_unref(message).chooseRegion) + " ", 1),
          _createElementVNode("i", _hoisted_9, [
            (_openBlock(), _createElementBlock("svg", {
              role: "img",
              width: "100%",
              height: "100%",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 320 512",
              class: _normalizeClass([{ 'moveDown': !show.value }])
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("path", {
                fill: "currentColor",
                d: "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
              }, null, -1)
            ]))], 2))
          ])
        ]),
        _createElementVNode("ul", {
          class: _normalizeClass(["dropdown-menu", show.value ? 'show' : '']),
          role: "menu"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(regionsDropdown), (region, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("a", {
                role: "menuitem",
                tabindex: "50",
                href: region.link
              }, _toDisplayString(region.name), 9, _hoisted_10)
            ]))
          }), 128))
        ], 2)
      ])
    ])
  ]))
}
}

})